import React from "react"

import { type IconProps } from "./utils"

export default function ChartIconSolid(props: IconProps) {
  return (
    <svg
      {...props}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.6165 3.75073C13.6165 3.06038 14.1762 2.50073 14.8665 2.50073H16.2582C16.9486 2.50073 17.5082 3.06038 17.5082 3.75073V16.2507C17.5082 16.9411 16.9486 17.5007 16.2582 17.5007H14.8665C14.1762 17.5007 13.6165 16.9411 13.6165 16.2507V3.75073Z"
        fill="#8B8D98"
      />
      <path
        d="M9.30827 7.08407C8.61791 7.08407 8.05827 7.64371 8.05827 8.33407V16.2507C8.05827 16.9411 8.61791 17.5007 9.30827 17.5007H10.6999C11.3903 17.5007 11.9499 16.9411 11.9499 16.2507V8.33407C11.9499 7.64371 11.3903 7.08407 10.6999 7.08407H9.30827Z"
        fill="#8B8D98"
      />
      <path
        d="M3.75 11.6674C3.05964 11.6674 2.5 12.227 2.5 12.9174V16.2507C2.5 16.9411 3.05964 17.5007 3.75 17.5007H5.14167C5.83202 17.5007 6.39167 16.9411 6.39167 16.2507V12.9174C6.39167 12.227 5.83202 11.6674 5.14167 11.6674H3.75Z"
        fill="#8B8D98"
      />
    </svg>
  )
}
